import { render } from "./BEmbed.vue?vue&type=template&id=7f2d8959"
import script from "./BEmbed.vue?vue&type=script&lang=js"
export * from "./BEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__